<template>
  <div>
    <div v-if="errored" class="errored">Une erreur s'est produite 😥</div>

    <div v-else-if="loaded" id="oblique" :class="'resume ' + person.lang">
      <div class="banner">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 595.3 841.9">
          <polygon points="595.3,368.5 595.3,0 0,0 0,141.5 " />
        </svg>
        <div class="container">
          <div>
            <h1>{{ person.name.first }} {{ person.name.last }}</h1>
            <span class="position">{{ person.position }}</span>
          </div>
          <img v-if="person.picture" :src="person.picture" class="profile" />
        </div>
      </div>

      <section v-if="person.about" class="section about">{{ person.about }}</section>

      <section v-if="person.experience.length" class="section experience">
        <h2>{{ lang.experience }}</h2>
        <div v-for="experience in person.experience" class="item">
          <h3>
            <span class="position">{{ experience.position }}</span
            ><br />{{ experience.company }} — <span class="timeperiod">{{ experience.timeperiod_from }} - {{ experience.timeperiod_to || lang.today }}</span>
          </h3>
          <div v-if="experience.description" class="description">{{ experience.description }}</div>
        </div>
      </section>

      <section v-if="person.education.length" class="section education">
        <h2>{{ lang.education }}</h2>
        <div v-for="education in person.education" class="item">
          <h3>
            <span class="position">{{ education.degree_role }}</span
            ><br />
            {{ education.degree_structure }} — <span class="timeperiod">{{ education.timeperiod }}</span>
          </h3>
          <div v-if="education.description" class="description">{{ education.description }}</div>
        </div>
      </section>

      <section v-if="person.projects.length" class="section projects">
        <h2>{{ lang.projects }}</h2>
        <div v-for="project in person.projects" class="item">
          <h3>
            <span class="position">{{ project.name }}</span
            ><br />
            {{ project.platform }} — <span class="timeperiod">{{ project.timeperiod_from }} - {{ project.timeperiod_to }}</span>
          </h3>
          <div v-if="project.description" class="description">{{ project.description }}</div>
        </div>
      </section>

      <section class="section skills">
        <h2>{{ lang.skills }}</h2>
        <div class="item container">
          <span v-for="skill in person.skills">
            <i class="material-icons">keyboard_arrow_right</i>
            {{ skill.name }}
          </span>
        </div>
      </section>

      <section class="section contact">
        <h2>{{ lang.contact }}</h2>
        <ul class="item">
          <li v-if="person.contact.street">
            <i class="fa fa-home"></i>
            {{ person.contact.street }}, {{ person.contact.city }}
          </li>
          <li>
            <i class="fa fa-envelope"></i>
            <a :href="contactLinks.email">{{ person.contact.email }}</a>
          </li>
          <li>
            <i class="fa fa-phone"></i>
            <a :href="'tel:' + person.contact.phone">{{ person.contact.phone }}</a>
          </li>
          <li v-if="person.contact.website">
            <i class="fa fa-globe"></i>
            <a :href="person.contact.website" target="_blank">{{ person.contact.website }}</a>
          </li>
          <li v-if="person.contact.github">
            <i class="fa fa-github"></i>
            <a :href="contactLinks.github" target="_blank">{{ person.contact.github }}</a>
          </li>
        </ul>
      </section>
    </div>
    <div v-else class="loading">Chargement en cours ⏰</div>
  </div>
</template>

<script>
import Vue from 'vue';
import { getVueOptions } from './options';

const name = 'oblique';
export default Vue.component(name, getVueOptions(name));
</script>

<style lang="less" scoped>
@page oblique {
  margin: 2cm 0;
}
@page oblique:first {
  margin-top: 0;
}

@primary-color: #6b7280;
@secondary-color: #fff;
@third-color: #164e63;
@four-color: #374151;
@normal: 11pt;
@big: 36pt;
@medium: 15pt;
@small: 10pt;

#oblique {
  position: relative;
  color: @primary-color;
  font-family: 'Brown', sans-serif;
  font-weight: 300;
  font-size: @normal;
  line-height: 17pt;
  page: oblique;
  .ar& {
    direction: rtl;
    font-family: 'Noto Sans Arabic', 'Brown', sans-serif;
    font-weight: 400;
  }

  .banner {
    position: relative;
    height: 13cm;

    .container {
      display: grid;
      grid-template-columns: 1fr 128px;
      justify-items: end;
      align-items: center;
      text-align: end;
      column-gap: 0.5cm;
      color: @secondary-color;
      position: relative;
      padding: 2cm 2cm 0;
    }

    svg {
      fill: @third-color;
      position: absolute;
      top: 0;
      left: 0;
      .ar& {
        transform: scaleX(-1);
      }
    }

    h1 {
      font-size: @big;
      line-height: 1;
      text-transform: uppercase;
      margin: 0;
      display: table-caption;
      font-weight: 800;
      .ar& {
        font-weight: 700;
      }
    }

    .position {
      display: table-caption;
      line-height: 1;
      margin-top: 10px;
    }

    .profile {
      border-radius: 100%;
      width: 128px;
      height: 128px;
      vertical-align: middle;
    }
  }

  .description {
    white-space: pre-line;
  }

  .section {
    margin: 2cm 0;
    padding: 0 2cm;
  }

  .about {
    color: @four-color;
    font-size: @medium;
    margin-top: -2cm;
    width: 50%;
    white-space: pre-line;
  }

  .item {
    width: 90%;

    &:not(:last-child) {
      margin-bottom: 0.3cm;
    }
  }

  h2 {
    margin-top: 0;
    margin-bottom: 0.3cm;
    color: @third-color;
    font-size: @medium;
    text-transform: uppercase;
    font-weight: 800;
    .ar& {
      font-weight: 700;
    }
  }

  h3 {
    font-size: @normal;
    text-transform: uppercase;
    margin: 0;
    .ar& {
      font-weight: 700;
    }
  }

  .position {
    font-weight: 300;
  }

  .timeperiod {
    text-transform: capitalize;
  }

  .skills .container {
    display: grid;
    grid-template-columns: auto auto;
    column-gap: 0.5cm;
    row-gap: 0.1cm;

    span {
      display: flex;
      font-size: @medium;
    }
  }

  .contact ul {
    margin: 0;
    padding: 0;
    list-style: none;

    a {
      color: @primary-color;
      text-decoration: none;
    }
  }
}
</style>
